import { PrePaymentReportRequestModel } from '../api/models/PrePaymentReportRequestModel';
import { PrePaymentReportFormModel } from '../models';

export const dataFormToRequest = (
  data: PrePaymentReportFormModel
): PrePaymentReportRequestModel => ({
  from: data.from,
  to: data.to,
  cash_register_ids: data.cash_register_ids,
  cashier_ids: data.cashier_ids,
  file_type: data.file_type,
  total_grouped: data.total_grouped,
});
